
export const common = {
  'call.us': 'اتصل بنا',
  'privacy.policy': 'سياسة الخصوصية',
  'select.location': 'حدد موقعك',
  'location.description': 'اختر موقعك للاتصال بالرقم المناسب',
  'usa': 'الولايات المتحدة',
  'non.usa': 'خارج الولايات المتحدة اتصال أو واتساب',
  'documents.downloads': 'المستندات والتنزيلات',
  'item': 'عنصر',
  'value': 'قيمة',
  'price': 'السعر',
  'product': 'منتج',
  'msrp': 'سعر التجزئة المقترح',
};
